import { addDoc, collection } from 'firebase/firestore';
import { logsPath } from './robotContract';

// Adds a task from buildTask (./robotCommands.js) to the robot's queue in a
// single write, so the robot never sees a half-written doc.
export function enqueueTask(db, sn, task) {
  return addDoc(collection(db, logsPath(sn)), task);
}
